module.exports = __webpack_public_path__ + "static/media/visit_1.5397052e.jpg";